// extracted by mini-css-extract-plugin
export var icon = "_ry-0";